var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMessageBubble = function SvgMessageBubble(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.002 0C2.455 0 1.047.837.385 2.15c-.662 1.313-.459 2.868.521 3.992-.184.647-.424 1.136-.634 1.292a.323.323 0 0 0-.157.204.305.305 0 0 0 .047.247.37.37 0 0 0 .307.113c.585 0 1.72-.532 2.108-.726 1.499.536 3.193.18 4.305-.907 1.112-1.085 1.426-2.69.799-4.077C7.053.901 5.605.001 4 0z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMessageBubble);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/message-bubble.cec658481c1b0742e1e8927e57525396.svg";